import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Box, Tab, Tabs } from '@mui/material'

import IccidAPI from '../../api/orbitV1/IccidAPI'
import MsisdnAPI from '../../api/orbitV1/MsisdnAPI'
import ProvisionAPI from '../../api/orbitV1/ProvisionAPI'
import DataGridMUI from '../../common/AbstractDataGrid/DataGridMUI'
import StatContainer from '../../common/AbstractStatLine/StatContainer'
import TabPanel from '../../common/TabPanel/TabPanel'
import { ColorBoxContent, ColorBoxHeader } from '../../common/ui/colorBox'
import useOrbitFlag from '../../hooks/useOrbitFlag'

import {
  iccidColDefs,
  msisdnColDefs,
  provisionStatusColDefs
} from './components/colDefs'
import UploadCsvBase from './components/UploadCsvBase'

const ICCID_LIMIT = 20
const MSISDN_LIMIT = 20
const PROVISIONING_QUEUE_LIMIT = 20

// duplicate code from ViewIndividualOrderPage
// should generalise the tab views
/** @type {Object.<string, import('@mui/styled-engine').CSSProperties>} */
const classes = {
  '& .MuiTab-root': {
    textTransform: 'initial',
    fontWeight: '600',
    fontSize: '16px',
    color: 'black'
  },
  '& .MuiTab-root.Mui-selected': {
    backgroundColor: 'blue',
    color: 'white'
  },
  '& .MuiTab-root.Mui-selected:first-of-type': {
    borderRadius: '8px 0px 0px 0px'
  }
}

export default function InventoryManagement() {
  /** @type {[import('../../types/iccid.type').IccidGetData, *]} */
  const [fetchedIccids, setFetchedIccids] = useState([])
  useEffect(() => {
    const getIccidStatus = async () => {
      try {
        const iccids = await IccidAPI.getIccid(ICCID_LIMIT)
        if (iccids && iccids.data) {
          setFetchedIccids(iccids.data)
        }
      } catch (error) {
        toast.error(error.message)
      }
    }

    getIccidStatus()
  }, [])

  /** @type {[import('../../types/msisdn.type').MsisdnGetData, *]} */
  const [fetchedMsisdns, setFetchedMsisdns] = useState([])
  useEffect(() => {
    const getMsisdnStatus = async () => {
      try {
        const msisdns = await MsisdnAPI.getMsisdn(MSISDN_LIMIT)
        if (msisdns && msisdns.data) {
          setFetchedMsisdns(msisdns.data)
        }
      } catch (err) {
        toast.error(err.message)
      }
    }

    getMsisdnStatus()
  }, [])

  /** @type {[import('../../types/provision.type').ProvisioningStatus, *]} */
  const [fetchedProvisioningQueue, setFetchedProvisioningQ] = useState([])
  useEffect(() => {
    const getProvisioningQStatus = async () => {
      try {
        const provisioningQueue = await ProvisionAPI.getProvisionQueue(
          PROVISIONING_QUEUE_LIMIT
        )

        if (provisioningQueue.data) {
          setFetchedProvisioningQ(provisioningQueue.data)
        }
      } catch (error) {
        toast.error(error.message)
      }
    }

    getProvisioningQStatus()
  }, [])

  const FlagStatContainer = useOrbitFlag('statContainer')
  const dataArray = [
    { title: 'Total Available ICCIDs', info: fetchedIccids.length },
    {
      title: 'Total Available MSISDNs',
      info: fetchedMsisdns.length
    }
  ]

  const [tabValue, setTabValue] = useState(0)
  const handleTabChange = (_, newNum) => setTabValue(newNum)

  return (
    <>
      <ColorBoxHeader>Manage Inventory</ColorBoxHeader>
      <Box
        sx={{
          display: 'flex',
          rowGap: '12px',
          flexDirection: 'column',
          marginTop: '12px'
        }}
      >
        {FlagStatContainer && <StatContainer dataArray={dataArray} />}
        <Box
          sx={{ backgroundColor: '#ECEFF4', borderRadius: '8px 8px 0px 0px' }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { display: 'none' }
            }}
            sx={classes}
          >
            <Tab label='Available ICCIDs' value={0} />
            <Tab label='Available MSISDNs' value={1} />
            <Tab label='Upload ICCIDs' value={2} />
            <Tab label='Upload MSISDNs' value={3} />
            <Tab label='Provisioning Status' value={4} />
          </Tabs>

          <ColorBoxContent style={{ borderRadius: '0px 0px 8px 8px' }}>
            <TabPanel value={tabValue} index={0}>
              <DataGridMUI
                rows={fetchedIccids}
                columns={iccidColDefs}
                getRowId={(row) => row.iccid}
              />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <DataGridMUI
                rows={fetchedMsisdns}
                columns={msisdnColDefs}
                getRowId={(row) => row.msisdn}
              />
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
              <UploadCsvBase itemType='iccid' />
            </TabPanel>
            <TabPanel value={tabValue} index={3}>
              <UploadCsvBase itemType='msisdn' />
            </TabPanel>
            <TabPanel value={tabValue} index={4}>
              <DataGridMUI
                rows={fetchedProvisioningQueue}
                columns={provisionStatusColDefs}
                getRowId={(row) => row.msisdn + '-' + row.iccid}
              />
            </TabPanel>
          </ColorBoxContent>
        </Box>
      </Box>
    </>
  )
}
